import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as LogInIcon } from './logIn.svg';

export const LogIn = IconHOC(LogInIcon);
